import { Button, Card, Form, Table, TableColumnsType } from 'antd';
import { FormatDate } from '../../../../../../constants';
import React from 'react';
import {
  SendReportCaseV1ActivityLogInput,
  SendReportCaseV1ActivityLog,
  CasesSendReportV1ActivityLogContainerSendReportCaseV1FieldsFragment
} from '../../../../../../generated';
import TextArea from 'antd/es/input/TextArea';
import useActivityForm from '../../../../../../hooks/useAcitivityForm';
import { Helmet } from 'react-helmet';

export interface ActivityLogProps {
  data: CasesSendReportV1ActivityLogContainerSendReportCaseV1FieldsFragment;
  onAddUpdateActivity: (values: SendReportCaseV1ActivityLogInput) => Promise<void>;
  isCaseOrApplicant: string;
}

const getFormattedState = (state: string) => {
  const stateFilters: {
    value: string;
    label: string;
  }[] = [
    { value: 'draft', label: 'Draft' },
    { value: 'submitted', label: 'Submitted' },
    { value: 'caseWorkerAssigned', label: 'Assigned' },
    { value: 'revisionRequested', label: 'Revision Requested' },
    { value: 'revisionSubmitted', label: 'Revision Submitted' },
    { value: 'decisionRendered', label: 'Decision Rendered' }
  ];

  return stateFilters.find((filter) => filter.value === state)?.label || state;
};

export const ActivityLog: React.FC<ActivityLogProps> = (props) => {
  const sortedLogs = [...(props.data?.activityLog ?? [])].sort((a, b) => new Date(b?.updatedAt).getTime() - new Date(a?.updatedAt).getTime());

  const columns: TableColumnsType<SendReportCaseV1ActivityLog> = [
    {
      title: 'Activity',
      dataIndex: 'activityType',
      key: 'activityType',
      render: (text: string) => {
        return getFormattedState(text);
      }
    },
    {
      title: 'Tags',
      dataIndex: 'tags',
      key: 'tags',
      render: (tags: string[]) => tags.join(', ')
    },
    {
      title: 'Activity By',
      dataIndex: ['activityBy', 'displayName'],
      key: 'activityBy',
      render: (activityBy: string) => activityBy ?? 'SYSTEM'
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'activityDescription'
    },
    {
      title: 'Date',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (text: any) => <span>{FormatDate(text)}</span>,
      sorter: (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
    }
  ];

  const ActivityTable: React.FC<{
    data: CasesSendReportV1ActivityLogContainerSendReportCaseV1FieldsFragment['activityLog'];
  }> = ({ data }) => (
    <Table
      columns={columns}
      dataSource={data ?? []}
      rowKey={(record: any) => record.id}
      pagination={false}
      rowHoverable={false}
      scroll={{
        y: 500
      }}
    />
  );

  const { form, loading, error, handleSubmit } = useActivityForm(props.onAddUpdateActivity);

  return (
    <>
      <Helmet>
        <title>{props?.isCaseOrApplicant} - Activity Log</title>
      </Helmet>
      <Card
        hoverable
        style={{
          width: '100%',
          height: '100%',
          marginTop: 20
        }}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <ActivityTable data={sortedLogs} />
          <br />
          <Form.Item name={['activityDescription']} label="Activity Description">
            <TextArea
              rows={4}
              placeholder="Add an update to the ticket."
              maxLength={2000}
              disabled={
                !props.data.isCurrentUserAssigned ||
                props.data.state === 'draft' ||
                props.data.state === 'decisionRendered' ||
                (props.data.state === 'revisionRequested' && props.data.isCurrentUserAssigned)
              }
            />
          </Form.Item>
          {error && <div style={{ color: 'red' }}>{error.message}</div>}
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              type="primary"
              htmlType="submit"
              value={'save'}
              loading={loading}
              disabled={
                !props.data.isCurrentUserAssigned ||
                props.data.state === 'draft' ||
                props.data.state === 'decisionRendered' ||
                (props.data.state === 'revisionRequested' && props.data.isCurrentUserAssigned)
              }
              style={{ float: 'inline-end' }}
            >
              Add Activity Update
            </Button>
          </div>
        </Form>
      </Card>
    </>
  );
};
